const ENGLISH = 'I agree to use an electronic signature and to sign this agreement electronically. '
  + 'My electronic signature has the same legal effect as my handwritten signature. '
  + 'I agree to receive this agreement and related program documents electronically at the email address on file, '
  + 'and I confirm I can open, save and print PDF files. '
  + 'I may request a free paper copy, or withdraw this consent, at any time using the contact details in this agreement; '
  + 'withdrawing does not cancel an agreement I have already signed.'

export const ESIGN_CONSENT = {
  version: 'v1-2026-10-05',
  english: ENGLISH,
  bilingual: ENGLISH,
}

const BILINGUAL_TYPE_DOCS = ['legalServiceAgreementSpanish']

export const esignConsentText = (typeDoc) =>
  BILINGUAL_TYPE_DOCS.includes(typeDoc) ? ESIGN_CONSENT.bilingual : ESIGN_CONSENT.english
